import { MdxDiv } from '@features/mdx/MdxDiv';
import { LanguageEnum } from '@project-types/LanguageEnum';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';



const articleIds: MdxPageArticleIds = {
	[LanguageEnum.CZ]: '29cb6fd1-0fbe-4da0-9e4b-280521b173f4',
	[LanguageEnum.SK]: '29cb6fd1-0fbe-4da0-9e4b-280521b173f4',
	default: '29cb6fd1-0fbe-4da0-9e4b-280521b173f4'
}


export const Advantages = () => {

	return (
		<MdxDiv className='advantages' articleIds={articleIds}>
		</MdxDiv>
	);
};